<script>
export default {
    name: "vip",
    data() {
        return {
            menu: [
                {
                    name: '无限展览',
                    icon: require('@/assets/images/icon_vip_nav_01.png'),
                    path: '/vip/exhibition'
                },
                {
                    name: '商店折扣',
                    icon: require('@/assets/images/icon_vip_nav_02.png'),
                    path: '/vip/shop'
                },
                {
                    name: '课程阅读',
                    icon: require('@/assets/images/icon_vip_nav_03.png'),
                    path: '/vip/course'
                },
                {
                    name: '独家预览',
                    icon: require('@/assets/images/icon_vip_nav_04.png'),
                    path: '/vip/exclusive'
                },
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="vip">
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url();`"></div>
            <div class="content layout_main">
                <p class="text">今天成为Ambassador<sup>+</sup>会员体验更多。</p>
            </div>
        </div>
        <div class="menu flex justify_center">
            <router-link class="item layout_flex_center flex_column " v-for="(item, index) in menu" :key="index" :to="item.path">
                <img :src="item.icon" alt="" class="icon"/>
                <p class="name">{{ item.name }}</p>
            </router-link>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 3.7rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
    }
    .content{
        .text{
            font-size: .24rem;
            padding-top: 2.6rem;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 4rem;
        .content{
            .text{
                padding-top: 3.1rem;
            }
        }
    }
}
.menu{
    border-top: 1px solid #666;
    border-bottom: 1px solid #666;
    height: 1.1rem;
    .item{
        width: 1rem;
        font-size: .18rem;
        position: relative;
        &::after{
            content: "";
            display: block;
            width: 100%;
            border-bottom: 2px solid #333;
            position: absolute;
            bottom: 0;
            left: 0;
            display: none;
        }
        &.active{
            &::after{
                display: flex;
            }
        }
        .icon{
            width: .45rem;
            height: .45rem;
            margin: 0 auto;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 1.4rem;
        .item{
            width: 1.2rem;
            font-size: .2rem;
            .icon{
                width: .6rem;
                height: .6rem;
            }
        }
    }
}
</style>